import React, {useState, useEffect} from 'react'
import {  CircularProgress } from '@material-ui/core'
//import { useHistory } from "react-router-dom"

import FaltuRoom from './FaltuRoom'
import ActualRoom from './ActualRoom'

import firebase from '../Services/firebase'
import RoomAuth from './RoomAuth'
import roomService from '../Services/room'

function Room() {

    const [isValidRoom, setIsValidRoom] = useState(true)
    const [loading, setLoading] = useState(true)
   // const [roomName, setRoomName] = useState("")
    const [room, setRoom] = useState({})

    useEffect(()=>{
        const searchUrl = window.location.search
        const params = new URLSearchParams(searchUrl)
        const roomName = params.get('name')
       // console.log(roomName)

        if (roomName){
            // var docRef = firebase.firestore().collection("rooms")
            
            // docRef.get().then(function(querySnapshot) {
            //     querySnapshot.forEach(function(doc) {
            //         // doc.data() is never undefined for query doc snapshots
            //         console.log(doc.data());
            //     });
            // });



            var starCountRef = firebase.database().ref('rooms/' +roomName)
            starCountRef.on('value', function(snapshot) {
                var roomData = snapshot.val()
                setRoom(roomData)
              //  console.log(roomData)
                if(roomData){
                    setLoading(false)
                }else{
                    setIsValidRoom(false)
                }
            })


        } else{
            setIsValidRoom(false)
        }
    }, [])


    return (
        <div>
            <div>
                {
                    loading ? (
                        <div style={{margin: '40px'}}>
                            <CircularProgress />
                        </div>
                    ) : (
                        <div>
                            {
                                isValidRoom ? (
                                    <RoomAuth room={room}/>
                                ) : (
                                    <FaltuRoom />
                                )
                            }
                        </div>
                    )
                }
            </div>
            
        </div>
    )
}

export default Room
